import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Loader2, MessageCircle } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ContactSection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const response = await fetch('https://formsubmit.co/ajax/nmservicesww@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          message: formState.message,
          _subject: 'New Contact Form Submission from NM Services Website',
          _captcha: 'false'
        })
      });
      if (response.ok) {
        setStatus('success');
        setFormState({
          name: '',
          email: '',
          message: ''
        });
        // Reset success message after 5 seconds
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('error');
    }
  };
  return <section id="contact" className="py-24 md:py-32 relative" data-id="element-34">
      <div className="container mx-auto px-4 md:px-6" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-36">
          {/* Left Column - Info */}
          <div ref={ref} className={`transition-all duration-1000 ${isRevealed ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`} data-id="element-37">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-38">
              Let's Build Your <br data-id="element-39" />
              <span className="text-[#c9a84c]" data-id="element-40">Vision</span>
            </h2>
            <p className="text-gray-400 text-lg mb-10 leading-relaxed" data-id="element-41">
              Ready to elevate your online presence? Contact us today to get
              started with your premium AI website package.
            </p>

            <div className="space-y-8" data-id="element-42">
              {/* Email */}
              <div className="flex items-start gap-4" data-id="element-43">
                <div className="p-3 bg-[#c9a84c]/10 rounded-lg shrink-0" data-id="element-44">
                  <Mail className="h-6 w-6 text-[#c9a84c]" data-id="element-45" />
                </div>
                <div data-id="element-46">
                  <h4 className="text-white font-medium mb-1" data-id="element-47">Email Us</h4>
                  <a href="mailto:nmservicesww@gmail.com" className="text-gray-400 hover:text-[#c9a84c] transition-colors" data-id="element-48">
                    nmservicesww@gmail.com
                  </a>
                </div>
              </div>

              {/* Netanel Contact */}
              <div className="flex items-start gap-4" data-id="element-49">
                <div className="p-3 bg-[#c9a84c]/10 rounded-lg shrink-0" data-id="element-50">
                  <Phone className="h-6 w-6 text-[#c9a84c]" data-id="element-51" />
                </div>
                <div className="flex-1" data-id="element-52">
                  <h4 className="text-white font-medium mb-1" data-id="element-53">
                    Contact Netanel
                  </h4>
                  <div className="flex flex-wrap items-center gap-3" data-id="element-54">
                    <a href="tel:+660960231920" className="text-gray-400 hover:text-[#c9a84c] transition-colors" data-id="element-55">
                      +66 096 023 1920
                    </a>
                    <a href="https://line.me/ti/p/8_u5SKjUVA" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-[#06C755] hover:bg-[#05b64d] text-white text-xs font-bold px-3 py-1 rounded-full transition-colors" data-id="element-56">
                      <MessageCircle className="h-3.5 w-3.5" data-id="element-57" />
                      LINE
                    </a>
                    <a href="https://wa.me/36707559881?text=hi%20im%20interested%20of%20AI%20website%20package" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-[#25D366] hover:bg-[#1fbd5a] text-white text-xs font-bold px-3 py-1 rounded-full transition-colors" data-id="element-58">
                      <MessageCircle className="h-3.5 w-3.5" data-id="element-59" />
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>

              {/* Vlad Contact */}
              <div className="flex items-start gap-4" data-id="element-60">
                <div className="p-3 bg-[#c9a84c]/10 rounded-lg shrink-0" data-id="element-61">
                  <Phone className="h-6 w-6 text-[#c9a84c]" data-id="element-62" />
                </div>
                <div className="flex-1" data-id="element-63">
                  <h4 className="text-white font-medium mb-1" data-id="element-64">Contact Vlad</h4>
                  <div className="flex flex-wrap items-center gap-3" data-id="element-65">
                    <a href="tel:+660933376318" className="text-gray-400 hover:text-[#c9a84c] transition-colors" data-id="element-66">
                      +66 093 337 6318
                    </a>
                    
                  </div>
                </div>
              </div>

              {/* Location */}
              <div className="flex items-start gap-4" data-id="element-67">
                <div className="p-3 bg-[#c9a84c]/10 rounded-lg shrink-0" data-id="element-68">
                  <MapPin className="h-6 w-6 text-[#c9a84c]" data-id="element-69" />
                </div>
                <div data-id="element-70">
                  <h4 className="text-white font-medium mb-1" data-id="element-71">Location</h4>
                  <p className="text-gray-400" data-id="element-72">Digital Nomad HQ, Global</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className={`bg-[#0a0a0a] p-8 rounded-xl border border-white/10 transition-all duration-1000 delay-300 ${isRevealed ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`} data-id="element-73">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-74">
              <div data-id="element-75">
                <label htmlFor="name" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-76">
                  Name
                </label>
                <input type="text" id="name" value={formState.name} onChange={e => setFormState({
                ...formState,
                name: e.target.value
              })} disabled={status === 'sending'} className="w-full bg-[#050505] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#c9a84c] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" placeholder="Your Name" required data-id="element-77" />
              </div>

              <div data-id="element-78">
                <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-79">
                  Email
                </label>
                <input type="email" id="email" value={formState.email} onChange={e => setFormState({
                ...formState,
                email: e.target.value
              })} disabled={status === 'sending'} className="w-full bg-[#050505] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#c9a84c] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" placeholder="your@email.com" required data-id="element-80" />
              </div>

              <div data-id="element-81">
                <label htmlFor="message" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-82">
                  Message
                </label>
                <textarea id="message" rows={4} value={formState.message} onChange={e => setFormState({
                ...formState,
                message: e.target.value
              })} disabled={status === 'sending'} className="w-full bg-[#050505] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#c9a84c] transition-colors resize-none disabled:opacity-50 disabled:cursor-not-allowed" placeholder="Tell us about your project..." required data-id="element-83" />
              </div>

              <button type="submit" disabled={status === 'sending'} className="w-full bg-[#c9a84c] text-black font-bold py-4 rounded-lg uppercase tracking-widest hover:bg-[#d4af37] hover:shadow-[0_0_20px_rgba(201,168,76,0.4)] transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-84">
                {status === 'sending' ? <>
                    Sending... <Loader2 className="h-4 w-4 animate-spin" data-id="element-85" />
                  </> : <>
                    Send Message <Send className="h-4 w-4" data-id="element-86" />
                  </>}
              </button>

              {status === 'success' && <div className="p-4 bg-green-500/10 border border-green-500/20 rounded-lg text-green-500 text-center" data-id="element-87">
                  Message sent successfully! We'll be in touch soon.
                </div>}

              {status === 'error' && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg text-red-500 text-center" data-id="element-88">
                  Something went wrong. Please try again later.
                </div>}
            </form>
          </div>
        </div>
      </div>
    </section>;
}